import { render, staticRenderFns } from "./delete_regiao.vue?vue&type=template&id=1087d3ee&scoped=true"
import script from "./delete_regiao.vue?vue&type=script&lang=js"
export * from "./delete_regiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087d3ee",
  null
  
)

export default component.exports